<template>
  <div class="view-leads">
    <div class="header mb-6">
      <vs-button
        color="dark"
        type="flat"
        icon-pack="feather"
        icon="icon-arrow-left"
        class="p-0"
        @click="goBack()"
      ></vs-button>
      <div class="pr-4 justify-right">
        <h2 class="pl-2">{{ $t("labels.question") }}</h2>
      </div>
      <feather-icon
        :title="$t('labels.refresh')"
        icon="RefreshCwIcon"
        class="cursor-pointer mt-1 sm:mr-6 mr-2"
        @click.prevent="getQuestion()"
      ></feather-icon>
    </div>
    <div class="inspect-question">
      <vx-card
        class="project-detail mb-6"
        :title="$t('labels.project_details')"
      >
        <div class="vx-row">
          <div class="vx-col w-full">
            <div class="vx-row mb-6">
              <div class="vx-col sm: w-1/2 md:w-1/5 label-center">
                <label>{{ $t("labels.project_name") }}:</label>
              </div>
              <div class="vx-col sm: w-1/2 label-center">
                <span>{{ project.name }}</span>
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm: w-1/2 md:w-1/5 label-center">
                <label>{{ $t("labels.date") }}:</label>
              </div>
              <div class="vx-col sm: w-1/2 label-center">
                <span>{{ project.date | only_date_format }}</span>
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm: w-1/2 md:w-1/5 label-center">
                <label>{{ $t("labels.vessel") }}:</label>
              </div>
              <div class="vx-col sm: w-1/2 label-center">
                <span v-if="project.vessel">{{ project.vessel.name }}</span>
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm: w-1/2 md:w-1/5 label-center">
                <label>{{ $t("labels.reviewer") }}:</label>
              </div>
              <div class="vx-col sm: w-1/2 label-center">
                <span v-if="project.reviewer">{{ project.reviewer.name }}</span>
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col sm: w-1/2 md:w-1/5 label-center">
                <label>{{ $t("labels.remarks") }}:</label>
              </div>
              <div class="vx-col sm: w-1/2 label-center">
                <span>{{ project.remarks }}</span>
              </div>
            </div>
            <div class="status">
              <vs-chip color="primary" class="status-name">{{
                project.status_name
              }}</vs-chip>
            </div>
          </div>
        </div>
      </vx-card>
      <vx-card
        :title="
          project_consultant_service_question.question
            .section_reference_number +
          ' - ' +
          project_consultant_service_question.question.question
        "
      >
        <div class="vx-row w-full mx-0">
          <div class="vx-col sm: w-full mt-6">
            <div class="vx-row mb-6">
              <div class="vx-col md:w-full label-center p-0">
                <div>
                  <!-- For consultant -->
                  <vx-card class="add-query">
                    <div
                      class="query-text"
                      v-if="project_consultant_service_question.query_text"
                    >
                      <label>{{ $t("labels.query_by_reviewer") }} :</label>
                      <span>{{
                        project_consultant_service_question.query_text
                      }}</span>
                    </div>
                    <div class="flex justify-center">
                      <vs-button
                        @click="getComments()"
                        color="dark"
                        type="border"
                        >{{ $t("labels.chat") }}</vs-button
                      >
                      <div
                        v-if="
                          project_consultant_service_question.query_status !==
                            'R' && $store.state.userInfo.type == 'A'
                        "
                        class
                      >
                        <vs-button
                          @click="openPopupForRaisedQuery()"
                          class="ml-6"
                          color="warning"
                          value="R"
                          type="border"
                          >{{ $t("labels.raise_query") }}</vs-button
                        >
                      </div>
                      <div
                        class="vx-col"
                        v-if="
                          ['R', 'A'].includes(
                            project_consultant_service_question.query_status
                          ) && $store.state.userInfo.type == 'A'
                        "
                      >
                        <vs-button
                          @click="
                            getProjectChangeQueryStatus(
                              project_consultant_service_question.id,
                              'MR'
                            )
                          "
                          class="ml-6"
                          color="primary"
                          value="MR"
                          type="border"
                          >{{ $t("labels.mark_as_resolved") }}</vs-button
                        >
                      </div>
                      <div
                        v-if="
                          project_consultant_service_question.query_status ===
                            'R' && $store.state.userInfo.type == 'CN'
                        "
                        class
                      >
                        <vs-button
                          @click="
                            getProjectChangeQueryStatus(
                              project_consultant_service_question.id,
                              'A'
                            )
                          "
                          class="float-right ml-6"
                          color="warning"
                          value="A"
                          type="border"
                          >{{ $t("labels.query_answered") }}</vs-button
                        >
                      </div>
                    </div>
                  </vx-card>
                  <!-- For consultant end -->
                  <div class="mt-6">
                    <div class="mt-6" v-if="all_vessel_types">
                      <vs-collapse>
                        <vs-collapse-item
                          icon-pack="feather"
                          icon-arrow="icon-arrow-down"
                        >
                          <div slot="header">
                            <label>{{
                              $t("labels.vessel_type_guidance")
                            }}</label>
                          </div>
                          {{ guidance }}
                        </vs-collapse-item>
                      </vs-collapse>
                    </div>
                  </div>
                  <div class="mt-6" v-if="!all_vessel_types && guidance">
                    <vs-collapse>
                      <vs-collapse-item
                        icon-pack="feather"
                        icon-arrow="icon-arrow-down"
                      >
                        <div slot="header">
                          <label>{{ $t("labels.vessel_type_guidance") }}</label>
                        </div>
                        {{ guidance }}
                      </vs-collapse-item>
                    </vs-collapse>
                  </div>
                  <div class="mt-2" v-if="!all_flags && flag_text != null">
                    <vs-collapse>
                      <vs-collapse-item
                        icon-pack="feather"
                        icon-arrow="icon-arrow-down"
                      >
                        <div slot="header">
                          <label>{{ $t("labels.flag_guidance") }}</label>
                        </div>
                        {{ flag_text }}
                      </vs-collapse-item>
                    </vs-collapse>
                  </div>
                  <div class="mt-2" v-if="regulation_reference">
                    <vs-collapse>
                      <vs-collapse-item
                        icon-pack="feather"
                        icon-arrow="icon-arrow-down"
                      >
                        <div slot="header">
                          <label>{{ $t("labels.regulation_reference") }}</label>
                        </div>
                        {{ regulation_reference }}
                      </vs-collapse-item>
                    </vs-collapse>
                  </div>

                  <div
                    class="mt-2"
                    v-if="
                      project_consultant_service_question.question.images &&
                      project_consultant_service_question.question.images.length
                    "
                  >
                    <vs-collapse>
                      <vs-collapse-item
                        icon-pack="feather"
                        icon-arrow="icon-arrow-down"
                      >
                        <div slot="header">
                          <label>{{ $t("labels.guidance_images") }}</label>
                        </div>
                        <div class="vx-row mt-6 justify-center swiper-height">
                          <div class="vx-col sm: w-full md:w-4/5">
                            <swiper
                              :options="swiperOption"
                              :dir="$vs.rtl ? 'rtl' : 'ltr'"
                              :key="$vs.rtl"
                            >
                              <swiper-slide
                                v-for="image in project_consultant_service_question
                                  .question.images"
                                :key="image"
                              >
                                <img
                                  class="swiper-lazy answer-image responsive"
                                  :data-src="image"
                                  alt="guidance-image"
                                />
                                <div
                                  class="swiper-lazy-preloader swiper-lazy-preloader-white"
                                ></div>
                              </swiper-slide>
                              <div
                                class="swiper-pagination swiper-pagination-white"
                                slot="pagination"
                              ></div>
                              <div
                                class="swiper-button-prev"
                                slot="button-prev"
                              ></div>
                              <div
                                class="swiper-button-next"
                                slot="button-next"
                              ></div>
                            </swiper>
                          </div>
                        </div>
                      </vs-collapse-item>
                    </vs-collapse>
                  </div>

                  <div class="vx-row mt-4">
                    <div class="vx-col sm: w-full md:w-1/2">
                      <label class="bold-fields">{{
                        $t("labels.images")
                      }}</label>
                      <vue-upload-multiple-image
                        :popupText="$t('labels.guidance_images')"
                        :dragText="$t('labels.browse_images')"
                        ref="multiple_image_"
                        primaryText
                        browseText
                        markIsPrimaryText
                        accept="image/jpeg, image/png, image/jpg"
                        @upload-success="uploadImageSuccess"
                        @before-remove="beforeRemove"
                        :data-images="images"
                        :maxImage="100"
                        class="w-full mb-2 mt-1 guidance-image"
                        :idUpload="'image-upload'"
                        name="image_upload"
                      ></vue-upload-multiple-image>
                    </div>
                    <div class="vx-col sm: w-full md:w-1/2 mt-1">
                      <div class="vx-row">
                        <div class="vx-col w-full pr-4 sm: mt-6 md:mt-0">
                          <label class>{{ $t("labels.defect") }}</label>
                          <v-select
                            v-model="defect_id"
                            :options="defects"
                            :reduce="(defects) => parseInt(defects.id)"
                            label="name"
                            name="defects"
                            v-validate="'required'"
                          />
                          <span class="text-danger text-sm">{{
                            errors.first("defects")
                          }}</span>
                        </div>
                        <div class="vx-col w-full mt-6">
                          <label class>{{ $t("labels.answer") }}</label>
                          <vs-textarea
                            type="text"
                            height="105"
                            class="w-full mb-0 mt-1"
                            name="answer_text"
                            :id="'answer-text'"
                            maxlength="5000"
                            v-model="answer_text"
                            :placeholder="$t('labels.write_answer')"
                            icon-no-border
                            v-validate="'required'"
                          />
                        </div>
                      </div>
                    </div>

                    <div class="vx-col sm: w-full mb-4 mt-6">
                      <div class="vx-row w-full m-0">
                        <label class>{{ $t("labels.audio_file") }}</label>
                        <div
                          class="w-full sm: block md:flex"
                          v-if="
                            !project_consultant_service_question.answer_attachment
                          "
                        >
                          <div class="vx-col sm: w-full md:w-1/2 mt-1">
                            <input
                              type="file"
                              accept=".mp3"
                              :name="
                                project_consultant_service_question.answer_attachment
                              "
                              id="answer_attachment"
                              class="mt-1"
                              v-on:change="handleFiles($event)"
                            />
                            <label for="answer_attachment" class="btn-1"
                              >Upload</label
                            >
                          </div>
                          <div
                            class="vx-col sm: w-full md:w-1/2 mt-1"
                            v-if="
                              project_consultant_service_question.answer_attachment
                            "
                          >
                            <audio controls id="audio_control">
                              <source
                                type="audio/mpeg"
                                :src="
                                  project_consultant_service_question.answer_attachment
                                "
                                id="'audio_source'"
                              />
                            </audio>
                          </div>
                        </div>
                        <div class="w-full sm: block md:flex audio-file" v-else>
                          <div class="vx-col sm: w-full md:w-1/2 mt-1 flex">
                            <p
                              class="self-center audio sm: mb-0"
                              id="audio_name"
                            >
                              {{
                                getFileName(
                                  project_consultant_service_question.answer_attachment
                                )
                              }}
                            </p>
                            <vs-button
                              color="danger"
                              type="flat"
                              class="mr-1 mt-1 float-right ml-2"
                              icon-pack="feather"
                              icon="icon-x"
                              v-model="cancel"
                              @click.prevent="clearFileName()"
                            ></vs-button>
                          </div>
                          <div class="vx-col sm: w-full md:w-1/2">
                            <audio controls id="audio_control_exit">
                              <source
                                type="audio/mpeg"
                                id="audio_source"
                                :src="
                                  project_consultant_service_question.answer_attachment
                                "
                              />
                            </audio>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="vx-col sm: w-full mb-4 mt-6">
                      <vs-button
                        class="vs-component vs-button md:w-auto md:mt-0 md:mb-0 vs-button-primary vs-button-filled login-btn float-right"
                        color="dark"
                        :disabled="button_loading"
                        id="save-answer"
                        button="submit"
                        @click.prevent="sendData()"
                        >{{ $t("labels.save_answer") }}</vs-button
                      >
                    </div>
                  </div>
                  <div class="query-status">
                    <vs-chip color="primary" class="mt-2 ml-1"></vs-chip>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <vs-popup
            class="holamundo"
            :title="$t('labels.raising_query')"
            :active.sync="popupActiveRaiseQuery"
          >
            <div class="vx-row">
              <div class="vx-col w-1/7">
                <vs-avatar
                  :text="this.$store.state.userInfo.name"
                  color="dark"
                  size="40px"
                  text-color="white"
                />
              </div>
              <div class="vx-col w-10/12">
                <vs-textarea
                  type="text"
                  class="w-full mb-0 mt-1"
                  name="query_text"
                  id="query_text"
                  maxlength="5000"
                  v-model="query_text"
                  :placeholder="$t('labels.type_your_query')"
                  icon-no-border
                />
              </div>
            </div>
            <div class="mt-6 submit-btn">
              <vs-button
                class="vs-component vs-button vs-button-primary vs-button-filled login-btn"
                color="primary"
                :disabled="button_loading"
                id="save-answer"
                button="submit"
                @click="submitQueryText()"
                >{{ $t("labels.submit") }}</vs-button
              >
            </div>
          </vs-popup>
        </div>
        <div
          class="query-status"
          v-if="project_consultant_service_question.query_status !== 'N'"
        >
          <vs-chip color="primary" class="mt-2 ml-1">{{
            project_consultant_service_question.query_status_name
          }}</vs-chip>
        </div>
      </vx-card>
      <vs-popup
        class="holamundo"
        :title="$t('labels.chat')"
        :active.sync="popupActive"
      >
        <div>
          <div
            class="vx-row"
            v-for="(comment, cindex) in comments"
            :key="cindex"
          >
            <div class="vx-col w-1/7">
              <vs-avatar
                :text="comment.user.name"
                color="dark"
                size="40px"
                text-color="white"
              />
            </div>
            <div class="vx-col w-10/12 label-center">
              <label class="comment-avatar">{{ comment.comment }}</label>
            </div>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col w-1/7">
            <vs-avatar
              :text="this.$store.state.userInfo.name"
              color="dark"
              size="40px"
              text-color="white"
            />
          </div>
          <div class="vx-col w-10/12">
            <vs-textarea
              type="text"
              class="w-full mb-0 mt-1"
              name="comment"
              id="comment"
              maxlength="5000"
              v-model="comment"
              :placeholder="$t('labels.type_message')"
              icon-no-border
            />
          </div>
        </div>
        <div class="mt-6 submit-btn">
          <vs-button
            class="vs-component vs-button vs-button-primary vs-button-filled login-btn"
            color="primary"
            :disabled="button_loading"
            id="save-answer"
            button="submit"
            @click="addProjectQuestionComments()"
            >{{ $t("labels.submit") }}</vs-button
          >
        </div>
      </vs-popup>
    </div>
  </div>
</template>
<script>
import VueUploadMultipleImage from "vue-upload-multiple-image";
import ViewProject from "@/layouts/components/projects/view-project.vue";
import "swiper/dist/css/swiper.min.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
  data() {
    return {
      answer_text: "",
      cancel: "",
      images: [],
      questions: "",
      question: [],
      question_drop: [],
      service_ids: "",
      id: this.$route.params.id,
      model: "project",
      defects: [],
      defect_id: null,
      defects_drop: [],
      comments: [],
      comment: "",
      popupActive: false,
      popupActiveRaiseQuery: false,
      query_text: "",
      flag_text: null,
      targeted_question_id: null,
      selected_question_index: null,
      guidance: "",
      raw_consultants: [],
      project: {},
      all_vessel_types: null,
      all_flags: null,
      regulation_reference: null,
      project_id: null,
      project_consultant_service_question: {},
      swiperOption: {
        // Enable lazy loading
        lazy: true,
        pagination: {
          el: ".swiper-pagination",
          type: "progressbar",
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
    };
  },
  components: {
    VueUploadMultipleImage,
    ViewProject,
    swiper,
    swiperSlide,
  },
  mounted() {
    this.getQuestion();
  },
  methods: {
    async getQuestion() {
      this.$vs.loading();
      let response = await this.getHTTPGetResponse(
        "/projects/question/" + this.$route.params.id
      );
      if (response) {
        let data = response.data;
        let question = data.project_consultant_service_question;
        this.project =
          question.project_consultant_service.project_consultant.project;
        this.project_id =
          question.project_consultant_service.project_consultant.project_id;
        this.answer_text = question.answer_text;
        this.defects = question.defects;
        this.defect_id = question.defect;
        let question_data = data.project_consultant_service_question.question;
        this.project_consultant_service_question =
          data.project_consultant_service_question;
        // Display stored images
        if (
          this.project_consultant_service_question.images != null &&
          this.project_consultant_service_question.images.length != 0
        ) {
          var images = [];
          this.project_consultant_service_question.images.forEach((element) => {
            if (element != null) {
              images.push({
                path: element,
                s3_url: element,
              });
            }
          });
          this.images = images;
        } else {
          this.images = [];
        }

        // Display vessel_types guidance
        this.regulation_reference = question_data.regulation_reference;
        let type_id = this.project.vessel_type_id;
        let sub_type_id = this.project.vessel_sub_type_id;
        if (!question_data.all_vessel_types) {
          let vessel_types = question_data.vessel_types;

          vessel_types.forEach((element) => {
            let que_vessel_type = element.question_vessel_type.vessel_type_id;

            if (que_vessel_type === type_id) {
              let vessel_sub_types =
                element.question_vessel_type.vessel_sub_types;
              vessel_sub_types.forEach((ele) => {
                let que_subvessel_type = ele.id;
                if (que_subvessel_type === sub_type_id) {
                  this.guidance = element.question_vessel_type.guidance;
                  return;
                }
              });
            }
          });
        } else {
          this.guidance = question_data.vessel_type_guidance;
        }
        let flag_id = this.project.vessel.flag_id;
        if (!question_data.all_flags) {
          let flags = question_data.flags;
          flags.forEach((element) => {
            let que_flag = element.id;

            if (que_flag === flag_id) {
              this.flag_text = question_data.flag_guidance;
              return;
            }
          });
          this.$vs.loading.close();
          return;
        }
      }
      this.$vs.loading.close();
    },
    openPopupForRaisedQuery() {
      this.popupActiveRaiseQuery = true;
    },
    // API Integration for Project Question Query Status
    async getProjectChangeQueryStatus(
      project_consultant_service_question_id,
      status
    ) {
      let input = {
        project_consultant_service_question_id,
        status,
      };
      let url = "/projects/change-query-status/" + this.project_id;
      let response = await this.getHTTPPostResponse(url, input, "", true);
      if (response) {
        this.getQuestion();
      }
    },
    async submitQueryText() {
      let input = {
        project_consultant_service_question_id:
          this.project_consultant_service_question.id,
        status: "R",
        query_text: this.query_text,
      };

      let url = "/projects/change-query-status/" + this.project_id;
      let response = await this.getHTTPPostResponse(url, input, "", true);
      if (response) {
        this.popupActiveRaiseQuery = false;
        this.getQuestion();
      }
    },

    /**
     * @function setSelectedCon
     * @description this function will invoke whenever v-select of consultans changes value
     */
    async sendData() {
      //  var name = "multiple_image_" + project_consultant_service_question.id;
      var images = this.$refs["multiple_image_"].images;
      var images_url = images.map((image) => {
        return image.s3_url;
      });
      var answer = {
        project_consultant_service_question_id:
          this.project_consultant_service_question.id,
        defect_id: this.project_consultant_service_question.defect_id,
        answer_text: this.project_consultant_service_question.answer_text,
        answer_attachment:
          this.project_consultant_service_question.answer_attachment,
        images: images_url,
      };

      let input = {
        answers: [],
      };

      input.answers.push(answer);
      this.recordInspection(input);
    },
    async recordInspection(input) {
      let url = "/projects/inspection/" + this.project_id;
      let response = await this.getHTTPPostResponse(
        url,
        input,
        "#save-answer",
        true
      );
      if (response) {
        this.getQuestion();
      }
    },
    getComments() {
      this.popupActive = true;
      this.comments = this.project_consultant_service_question.comments;
    },
    // API Integration for Project Question Comments
    async addProjectQuestionComments() {
      let input = {
        project_consultant_service_question_id:
          this.project_consultant_service_question.id,
        comment: this.comment,
      };
      let url = "/projects/comment/" + this.project_id;
      let response = await this.getHTTPPostResponse(url, input, "", true);
      if (response) {
        this.comment = "";
        this.popupActive = false;
        this.getQuestion();
      }
    },
    getFileName(url) {
      var filename = url.substring(url.lastIndexOf("/") + 1);
      return filename;
    },
    clearFileName() {
      this.project_consultant_service_question.answer_attachment = "";
    },
    async handleFiles(event) {
      // var files = event.target.files;
      // $("#audio_source" + index).attr("src", URL.createObjectURL(files[0]));
      // document.getElementById("audio_control" + index).load();
      let file = event.target.files[0];
      if (file.type !== "audio/mp3") {
        event.target.files[0].value = "";
      }
      // upload s3
      var input = new FormData();
      input.append("directory", "audio_file");
      input.append("attachment", file);
      let response = await this.getHTTPPostResponse(
        "/s3/upload",
        input,
        "",
        true
      );
      this.project_consultant_service_question.answer_attachment =
        response.data.url;
    },
    // Images Logic
    dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    },
    uploadImageSuccess(forData, index, fileList) {
      let fileImage = this.dataURLtoFile(
        fileList[index].path,
        fileList[index].name
      );
      // let flag = 1;
      if (
        !(
          fileImage.type === "image/png" ||
          fileImage.type === "image/jpeg" ||
          fileImage.type === "image/jpg"
        )
      ) {
        alert("Please upload image with extension .png ,.jpg, .jpeg");
        flag = 0;
        this.images.splice(index, 1);
        return false;
      }
      if (fileImage.size >= 10000000) {
        alert("Please upload under 10mb!");
        this.images.splice(index, 1);
        return false;
      } else {
        var input = new FormData();
        input.append("directory", "listing");
        input.append("attachment", fileImage);
        this.axios
          .post("s3/upload", input)
          .then((response) => {
            let data = response.data.data;

            fileList[index].s3_url = data.url;
            this.$vs.notify({
              title: "Success.",
              text: response.data.message,
              color: "success",
              position: "top-right",
            });
          })
          .catch((e) => {
            this.showError(e);
          });
      }
    },
    beforeRemove(index, done, fileList) {
      this.url = fileList[index].s3_url;
      this.index = index;
      this.remove_data = {
        index: index,
        done: done,
      };
      this.$vs.dialog({
        type: "confirm",
        color: "rgba(var(--vs-primary),1)",
        title: this.$t("labels.delete"),
        acceptText: this.$t("labels.yes"),
        cancelText: this.$t("labels.no"),
        text: this.$t("strings.delete_confirm"),
        accept: this.removeImage,
      });
    },
    removeImage() {
      let input = {
        url: this.url,
      };
      this.axios
        .post("s3/remove", input)
        .then((response) => {
          // show notification only
          // if new image is deleted.
          this.remove_data.done();
          if (!this.remove_data.edit) {
            this.$vs.notify({
              title: "Success.",
              text: response.data.message,
              color: "success",
              position: "top-right",
            });
          }
          return "tttttt";
        })
        .catch((e) => {
          this.images.splice(this.remove_data.index, 1);
          this.remove_data.done();
          this.showError(e);
        });
    },
    goBack() {
      history.back();
    },
  },
};
</script>
<style scoped>
.view-leads label {
  font-weight: 600;
  margin-right: 10px;
}
h2 {
  font-size: 20px;
  font-weight: 600;
  color: rgba(var(--vs-dark), 1);
}
.consultant-border {
  border-bottom: 2px solid #f8f8f8;
}
.question-feather {
  vertical-align: middle;
}
.label-center {
  align-self: center !important;
}
a,
a:hover {
  color: #626262;
  text-decoration: none;
}
.audio {
  -webkit-text-stroke-width: thin;
}
[type="file"] {
  height: 0;
  overflow: hidden;
  width: 0;
}

[type="file"] + label {
  background: rgba(var(--vs-dark), 1);
  border: none;
  border-radius: 5px;
  color: #fff;
  cursor: pointer;
  display: inline-block;
  font-family: "Poppins", sans-serif;
  font-size: inherit;
  font-weight: 500;
  margin-bottom: 1rem;
  outline: none;
  padding: 1rem 50px;
  position: relative;
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
  vertical-align: middle;
}
[type="file"] + label:hover {
  background-color: rgba(var(--vs-dark), 1);
}
[type="file"] + label.btn-1 {
  background-color: rgba(var(--vs-dark), 1);
  box-shadow: 0 6px #00449cd1;
  -webkit-transition: none;
  transition: none;
}
[type="file"] + label.btn-1:hover {
  box-shadow: 0 4px #00449cd1;
  top: 2px;
}
.service-border {
  border-bottom: 2px solid #f6f6f6;
}
.audio-file {
  align-items: flex-end;
}
.raise-question {
  position: absolute;
  right: 21px;
}
.comment-avatar {
  word-break: break-all;
}
.add-query {
  box-shadow: none !important;
  border: 1px solid #f1f1f1;
}
.submit-btn {
  text-align: center;
}
.header svg {
  width: 20px !important;
  height: 20px !important;
  color: rgba(var(--vs-dark), 1);
}

.swiper-container {
  max-height: 50%;
  height: 100% !important;
  background-color: rgba(0, 0, 0, 0.7) !important;
}
.responsive {
  max-height: 100% !important;
  height: 100% !important;
}
.swiper-height {
  max-height: 505px;
}
</style>
